import React from "react";
import { formatWhatsAppText } from "../../utils/formatWhatsAppText";

/**
 * WhatsAppFormattedText
 * Renderiza texto con formato WhatsApp (*bold*, _italic_, ~strikethrough~, ```monospace```)
 */
export default function WhatsAppFormattedText({ text, className = "" }) {
  if (!text || typeof text !== "string") return null;

  const segments = formatWhatsAppText(text);

  return (
    <span className={className}>
      {segments.map((seg, i) => {
        const key = `wa-${i}-${seg.type}`;
        if (seg.type === "plain") {
          return <span key={key}>{seg.content}</span>;
        }
        if (seg.type === "bold") {
          return (
            <strong key={key} className="font-bold">
              {seg.content}
            </strong>
          );
        }
        if (seg.type === "italic") {
          return (
            <em key={key} className="italic">
              {seg.content}
            </em>
          );
        }
        if (seg.type === "strikethrough") {
          return (
            <s key={key} className="line-through">
              {seg.content}
            </s>
          );
        }
        if (seg.type === "monospace") {
          return (
            <code
              key={key}
              className="font-mono text-[0.9em] bg-gray-100 px-1 rounded"
            >
              {seg.content}
            </code>
          );
        }
        return <span key={key}>{seg.content}</span>;
      })}
    </span>
  );
}
